// extracted by mini-css-extract-plugin
export default {"container":"zHsCml","start":"i7Yl1q","center":"zm_qyN","end":"IqEl0j","xs":"lSQwl4","copy":"rEiXmM","lg":"PwWdwG","content":"ErTWD0"};